enum ScreenshotStatus {
  PENDING = 'pending',
  WAITING_FOR_MATCH = 'waiting_for_match',
  SUCCESS = 'success',
  FAILED = 'failed',
}

export default ScreenshotStatus;
